<template>
    <div class="login-wrapper-page">

        <div class="panel login-panel">
            <div class="login-panel-heading">
                <div class="login-logo"></div>
            </div>

            <div class="login-panel-body">
                <h5 class="text-muted text-center"><b> Please enter your account email address.</b></h5>
                <form class="form-horizontal" style="margin: 20px;">
                    <div class="row form-group text-center">
                        <div class="col-xs-12">
                            <input placeholder="Email Address" type="text" v-model="emailAddress" style="margin: 0 0 20px 0;">
                        </div>
                        <div class="col-xs-12">
                            <ac-button class="btn-sm btn-blue" :action="resetPassword" style="margin-bottom: 10px; width:100%">
                                VERIFY ACCOUNT
                            </ac-button>
                        </div>
                        <div class="col-xs-12">
                            <ac-button class="btn-sm btn-red" :action="cancel" style="margin-bottom: 20px; width:100%">
                                CANCEL
                            </ac-button>
                        </div>
                        <div class="col-xs-12 text-center text-muted" style="margin-bottom: 10px;">
                            If you do not have your email information please contact
                            <a :href="'mailto:' + supportEmail" target="_blank">{{supportEmail}}</a>
                            for further assistance.
                        </div>
                        <div class="col-xs-12">
                            <p><img class="center-block" src="../../../assets/images/hipaa-150.png"></p>
                        </div>
                    </div>
                </form>
            </div>
        </div> <!--close panel -->
    </div>
</template>

<script>
    import {common} from "../../../global/common.js";
    import {validators} from "../../../global/validators.js";
    import {notifications} from "../../../global/notifications.js";
    import {api} from "../../../global/framework/api.js";
    import {customStyleLoader} from "../../../global/customStyleLoader.js";

    export default {
        name: "UserVerification",
        data: function () {
            return {
                supportEmail: "support@accresa.com",
                emailAddress: ""
            }
        },
        async mounted() {
            let result =  await customStyleLoader.loadCustomStyleFromUrl(this.$route);

            if (result && result.supportEmail) {
                this.supportEmail = result.supportEmail;
            }
        },
        methods: {
            async resetPassword() {
                if (validators.validateEmail(this.emailAddress)) {
                    await api.post('Account', 'UserVerification', {email: this.emailAddress});
                } else {
                    notifications.show({title: 'ERROR', message: 'Please enter a valid email address.'}, common.ACRESSA_NOTIFICATIONS.ERROR);
                }
            },
            cancel() {
                common.goBack();
            }
        }
    }
</script>

<style scoped>

</style>